"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const getFaqs_1 = __importDefault(require("../../utils/cms/getFaqs"));
/**
 * Returns formatted City info
 * @param {object} city
 * @returns {CityFactoryType}
 */
function cityFactory(city) {
    return {
        cityId: (0, get_1.default)(city, 'lumiId', ''),
        name: (0, get_1.default)(city, 'name', ''),
        slug: (0, get_1.default)(city, 'slug', ''),
        branchCount: (0, get_1.default)(city, 'branchCount', ''),
        cityImage: (0, get_1.default)(city, 'cityImage.url', ''),
        faqs: (0, getFaqs_1.default)((0, get_1.default)(city, 'faqs', [])),
        branchDescription: {
            title: (0, get_1.default)(city, 'cityDescription.title', ''),
            description: (0, get_1.default)(city, 'cityDescription.description', ''),
        },
        metaTitle: (0, get_1.default)(city, 'metatitle', ''),
        metaDescription: (0, get_1.default)(city, 'metadescription', ''),
        pageHeading: (0, get_1.default)(city, 'pageheading', ''),
        pageSubheading: (0, get_1.default)(city, 'pagesubheading', ''),
    };
}
exports.default = cityFactory;
